<div #videoCallModalReactWrapperComponent></div>